import { useGameStateContext } from 'app/src/game/GameStateContext';
import { useLevelContext } from 'app/src/game/LevelContext';
import Modal from 'app/src/modals/Modal';
import * as React from 'react';

type Props = {
	onClose: () => void;
};

export default function InfoModal({ onClose }: Props): React.ReactElement {
	const { currentLevel } = useLevelContext();
	const { gameStateStore } = useGameStateContext();

	return (
		<Modal className="InfoModal">
			<div className="InfoModal-screen">
				<h1 className="InfoModal-title">
					{currentLevel}: {gameStateStore.title}
				</h1>
				<div className="InfoModal-description">{gameStateStore.description}</div>
			</div>
			<div className="InfoModal-buttonContainer">
				<button onClick={onClose} className="InfoModal-button">
					Close
				</button>
			</div>
		</Modal>
	);
}
